module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"sending_control_attachments_to_ged":"Envoi des piéces jointes liées au contrôle en GED","send_control_attachments_to_ged":"Envoyer les pièces jointes en GED","synchronization_date_time":"Date de derniére synchronisation","synchronized_by":"Effectuée par"}}')
  delete Component.options._Ctor
}
